<template>
  <section v-maximizable>
    <div class="table-tab">
      <div class="table-tab__container">
        <table class="table-tab__block table">
          <thead class="table-tab__thead">
          <tr class="">
            <th class="table-tab__border-bottom table-tab__th--row table-tab__border-right"></th>
            <th class="table-tab__border-bottom">
              {{$t('form.lot.parts.date')}}
            </th>
            <th class="table-tab__border-bottom">
              {{$t('form.lot.parts.date-in-bid')}}
            </th>
          </tr>
          </thead>
          <tbody class="table-tab__tbody">
            <template v-for="(check, idx) in checks">
              <tr class="table-tab__border-bottom">
                <th class=" table-tab__th--row table-tab__border-bottom table-tab__border-right table-tab__btn-open">
                  <span class="table-tab__color u-padding-left-30">{{$t('form.lot.parts.part-number', {id: idx + 1})}}</span>
                </th>
                <td>
                  <label class="a-checkbox__label">
                    <input class="a-checkbox__input" type="checkbox" v-model="checks[idx]" :disabled="true">
                    <span class="a-checkbox__icon"><i></i></span>
                  </label>
                </td>
                <td>
                  <date-time v-model="dates[idx]" :time="false"></date-time>
                </td>
              </tr>
            </template>
          </tbody>
        </table>
      </div>
    </div>
  </section>
</template>

<script>
  export default {
    props: {
      lot: Object
    },

    computed: {
      checks() {
        return this.lot.checkDates;
      },

      dates() {
        return this.lot.dates;
      }
    },
  }
</script>

<style scoped>

</style>
